import { FC } from 'react'

import { MessageReference } from 'types/Api'

import { GoToReferenceButton } from './GoToReferenceButton'
import { ReferenceContent } from './ReferenceContent'

type Props = {
  messageId: string
  reference: MessageReference
}

export const ReferencePreview: FC<Props> = ({ messageId, reference }) => (
  <div className="mt-3 overflow-hidden print:hidden">
    <div className="flex flex-col gap-y-3">
      <GoToReferenceButton reference={reference} />
      <ReferenceContent reference={reference} messageId={messageId} />
    </div>
  </div>
)
